import { head } from 'ramda';
import { getFileDescriptor } from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
import { HttpClient } from '@wix/http-client';
import { getCopyableWixUrl } from './media-manager-sdk/wix-url';
import { copyToClipboard } from './copyToClipboard';
import { ActionName } from '../constants/Bi';
import { urlCopiedNotification } from '../containers/FilesManager/notifications';
import { MediaManagerSDKFile } from './media-manager-sdk';

export interface CopyWixUrlOptions {
  notify?: (notification: any) => void;
  trackActionsDone?: (actionName: ActionName) => void;
}

export const copyWixUrlToClipboard = async (
  httpClient: HttpClient,
  selectedItems: MediaManagerSDKFile[],
  options?: CopyWixUrlOptions,
): Promise<void> => {
  const { notify, trackActionsDone } = options || {};

  if (!selectedItems.length) {
    console.warn('No items selected for copying Wix URL');
    return;
  }

  try {
    const selectedFileIds = selectedItems.map((item) => item.id);
    const mediaType = head(selectedItems).mediaType;

    const fileDescriptorsResponse = await httpClient.request(getFileDescriptor({ fileId: head(selectedFileIds) }));

    const firstFile = fileDescriptorsResponse.data?.file;
    const wixUrl = await getCopyableWixUrl(firstFile, mediaType);

    copyToClipboard(wixUrl);

    if (notify) {
      notify(urlCopiedNotification());
    }

    if (trackActionsDone) {
      trackActionsDone(ActionName.CopyWixUrl);
    }
  } catch (error) {
    console.error('Failed to copy Wix URL', error);
  }
};
